import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { shortenText, calcMonthsTextForSelectBox } from '../../../common/shared/statelessMethods';

const PdfRow = ({ apt }) => {
    const { t } = useTranslation();

    const [oneTimeDebt, setOneTimeDebt] = useState();
    const [monthlyDebt, setMonthlyDebt] = useState();
    const [monthlyComment, setMonthlyComment] = useState('');
    const [oneTimeComment, setOneTimeComment] = useState('');

    useEffect(() => {
        apt?.oneTimeLeft > 0 && setOneTimeDebt(apt.oneTimeLeft)
        apt?.pastPaymentsLeft && setMonthlyDebt(apt.pastPaymentsLeft)

        const monthlyDescr = apt?.openMonthDebtPayments ? shortenText(calcMonthsTextForSelectBox(apt?.openMonthDebtPayments)) : '';
        setMonthlyComment(monthlyDescr?.originalComment || monthlyDescr?.shortComment || monthlyDescr);
        const oneTimeDescr = apt?.openOneTimePayments?.length ? apt.openOneTimePayments.reduce((acc, curVal, index) => `${acc} ${curVal.payment_description}${index < apt.openOneTimePayments.length - 1 ? ',' : ''}`, '') : '';
        setOneTimeComment(oneTimeDescr);
    }, [apt]);

    return (
        <>
            {oneTimeDebt && oneTimeDebt > 0 && (
                <div className='pdf-row'>
                    <div className='debt'>{apt?.apartmentNumber}</div>
                    <div className='debt'>{t('reports.special_payment')}</div>
                    <div className='debt'>{oneTimeComment}</div>
                    <div className='debt'>{oneTimeDebt}</div>
                </div>
            )}
            {monthlyDebt && monthlyDebt > 0 && (
                <div className='pdf-row'>
                    <div className='pdf-highlited debt'>{apt?.apartmentNumber}</div>
                    <div className='debt'>{t('reports.monthly_fee')}</div>
                    <div className='debt'>{monthlyComment}</div>
                    <div className='debt'>{monthlyDebt}</div>
                </div>
            )}
        </>
    )
}

export default PdfRow;